/* RESPONSIBLE TEAM: team-actions */

import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class ProcedureController extends Controller {
  queryParams = ['aiDraft', { releaseId: 'release_id' }];

  @tracked aiDraft: string | null = null;
  @tracked releaseId: string | null = null;
}
